module.exports = __webpack_public_path__ + "img/opencloudos.b0de8314.png";